import script from "./MysticsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticsTab.vue?vue&type=script&setup=true&lang=js"

import "./MysticsTab.vue?vue&type=style&index=0&id=703e67c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703e67c5"]])

export default __exports__